import PreviewsCategoryItem from "./preview-category-item";

const PreviewsCategory = ({
  categories,
  previewCategory,
  previewSetSelected,
  isVisiblePrev,
  isVisibleNext,
  viewportRef,
  previewSetCategory,
  scrollNext,
  scrollPrev,
  analytics
}: {
  categories: { key: string; description: string }[];
  previewCategory: string;
  previewSetSelected: Function;
  isVisiblePrev: boolean;
  isVisibleNext: boolean;
  viewportRef: any;
  previewSetCategory: Function;
  scrollNext: Function;
  scrollPrev: Function;
  analytics: any
}) => {
  return (
    <div className="social">
      <button
        style={{ display: isVisiblePrev ? "block" : "none" }}
        className="social__switcher social__switcher_previous"
        onClick={() => scrollPrev()}>
        previous
        <i className="icon__previous" />
      </button>
      <div className="embla" ref={viewportRef}>
        <ul className="social__list embla__container">
          <PreviewsCategoryItem
            isDesktop={true}
            analytics={analytics}
            desktopProps={{
              socialList: categories,
              previewCategory: previewCategory,
              previewSetCategory: previewSetCategory,
              previewSetSelected: previewSetSelected,
            }}
          />
        </ul>
      </div>
      <button
        style={{ display: isVisibleNext ? "block" : "none" }}
        onClick={() => scrollNext()}
        className="social__switcher social__switcher_next">
        next
        <i className="icon__next" />
      </button>
    </div>
  );
};

export default PreviewsCategory;
